import React from "react";

export default function PaginationBar({
  page,
  totalPages,
  totalItems,
  pageSize,
  label = "items",
  onPageChange,
}) {
  if (!totalPages || totalPages <= 1) return null;
  const currentPage = Math.max(1, page || 1);
  const perPage = pageSize || 10;
  const total = totalItems || 0;
  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, total);

  return (
    <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="text-xs md:text-sm font-medium text-gray-700">
        Showing page{" "}
        <span className="font-bold text-gray-900">{currentPage}</span>{" "}
        of <span className="font-bold text-gray-900">{totalPages}</span>{" "}
        (Total: <span className="font-bold text-red-600">{total}</span>{" "}
        {label})
      </div>
      <div className="flex gap-2 items-center justify-center">
        <button
          type="button"
          onClick={() => onPageChange && onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`px-4 py-2 border rounded-lg font-medium text-xs md:text-sm transition-colors ${
            currentPage === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
          }`}
        >
          Previous
        </button>
        <span className="text-xs md:text-sm text-gray-700">
          <span className="font-bold">{total ? start : 0}</span>{" "}
          -{" "}
          <span className="font-bold">{total ? end : 0}</span>{" "}
          of <span className="font-bold text-red-600">{total}</span>
        </span>
        <button
          type="button"
          onClick={() => onPageChange && onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 border rounded-lg font-medium text-xs md:text-sm transition-colors ${
            currentPage === totalPages
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
}

